import axios from 'axios';

const baseURL = `api/functions`;

export default {
    extractDependencies(anchor: number, selectedValues: string) {
        const token = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return axios.get(`${baseURL}?anchor=${anchor}&selectedValues=${selectedValues}`);
    },
};
